<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<c-form ref="searchForm" inline>
<!--					<c-form-item type="input" label="会员名" name="login_name"></c-form-item>-->
					<c-form-item type="input" label="代理手机号" name="user_manage_mobilephone"></c-form-item>
					<c-form-item type="datetime" date-type="date" label="统计时间" start-name="start_date" end-name="end_date"></c-form-item>
				</c-form>
			</m-search>

			<m-operate>
				<c-button power="b_statistic_platform_user_export" @click="exportData()">导出</c-button>
			</m-operate>
			
			<c-table ref="table">				

				<c-table-column
					label="代理手机号"
					name="user_manage_mobilephone"
					width="120"
				>
				</c-table-column>
				
				<c-table-column
					label="下单数量"
					name="order_quantity"
					width="100"
				>
				</c-table-column>
				
				<c-table-column
					label="下单总额"
					name="order_amount"
					width="110"
				>
					<template v-slot="{data}">
						￥{{data.order_amount}}
					</template>
				</c-table-column>


				<c-table-column
					label="退款数量"
					name="refund_quantity"
					width="100"
				>
				</c-table-column>

				<c-table-column
					label="退款总额"
					name="refund_amount"
					width="110"
				>
					<template v-slot="{data}">
						￥{{data.refund_amount}}
					</template>
				</c-table-column>

				<c-table-column
					label="售后数量"
					name="return_quantity"
					width="100"
				>
				</c-table-column>

				<c-table-column
					label="售后总额"
					name="return_amount"
					width="110"
				>
					<template v-slot="{data}">
						￥{{data.return_amount}}
					</template>
				</c-table-column>

			</c-table>
		</module>
	</page>
</template>

<script>
	export default {
		name: 'm_statistic_platform_user',
		data() {
			return {
				
			}
		},
		
		mounted() {
			this.$refs.search.search();
		},
		
		methods: {
			searchHandle(data) {
				this.$refs.table.load({
					url: '/statistic/platform_user/list',
					data
				});
			},
			exportData(){
				var exportData = this.$refs.searchForm.serialize();
				exportData.job_id = 31;
				exportData.create_system = 'OMS';
				
				this.request({
					url: '/export_job/add',
					data: exportData,
					success: data => {
						this.$message({
		                  	text: '导出任务创建成功，请前往任务中心查看导出进度',
		                  	icon: 'success'
		                });
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	
</style>